/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const meetingYouChat = [
  { type: 'heading', level: 2, text: 'Chat' },
  {
    type: 'paragraph',
    text: 'Ask Sia about this meeting — follow-ups, summaries, or drafting messages to the team.',
  },
  {
    type: 'paragraph',
    text: 'Example: “Draft a short recap for #mission-control based on today’s standup.”',
  },
]
